import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { HomeComponent } from './home/containers/home/home.component'
import { CollectionComponent } from './collection/containers/collection/collection.component'
import { AdminComponent } from './admin/containers/admin/admin.component'
import { AdminLoginComponent } from './admin/containers/admin-login/admin-login.component'
import { EmbedCollectionComponentComponent } from './collection/components/embed-collection/embed-collection.component'

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
    data: {
      metainfo: {
        title:
          'Color collection management tool',
        description:
          ''
      }
    }
  },

  { path: 'admin', component: AdminComponent },
  { path: 'admin/login', component: AdminLoginComponent },

  { path: ':collectionId', component: CollectionComponent },
  { path: ':collectionId/embed', component: EmbedCollectionComponentComponent },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/app-routing.module.ts